import store from '@/store'

export default function apiLocalize(key) {
  let locale = store.getters.locale;
  let apiLocales = store.getters.apiLocales;
  return apiLocales[`${key}_${locale}`] || '...';
}
